<template>
  <b-modal no-fade v-model="dialog.show" size="lg" :id="`modal-symbol-${uniqueId}`"
           :hide-footer="true" centered @close="closeModal"
           no-close-on-backdrop
  >
    <template #modal-title>
     <span>
       {{ $t('trade.closeManyTradesConfirmation') }}
     </span>
    </template>
    <div>
      <h5 class="text-capitalize">{{$t('trades')}}: {{orderIds.join(", ")}}</h5>
      <b-input-group size="sm"  style="width: 100%">
        <template #append>
          <div @click="dialog.showGraph = dialog.showGraph=!dialog.showGraph" class="border" style="background-color: #fafafa; cursor: pointer; width: 100%; min-width: 30px; margin-left: -10px; z-index: 9;border-radius: 0 5px 5px 0">
            <i class="fa-solid fa-chart-column" style="font-size: 16px; margin-top: 5px; padding: 0 5px"></i>
          </div>
        </template>
        <b-form-input v-bind:value="tradeDetails.symbolId" disabled/>
      </b-input-group>
      <b-row class="mt-1">
        <b-col cols="6">
          <b-form-group class="m-0">
            <b-input-group size="sm" :prepend="$t('trade.closedPrice')" style="width: 100%">
              <b-input v-model="tradeDetails.closePrice" v-bind:disabled="tradeDetails.currentClosePrice"></b-input>
              <template #append>
                <b-button variant="outline-warning" size="sm"  v-b-tooltip :title="$t('operations.sync')" @click="syncPrice">
                  <i class="fa-solid fa-sync"></i>
                </b-button>
              </template>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <date-time-picker :prepend="$t('trade.closeTime')" size="sm" v-model="tradeDetails.closeTime" v-bind:disabled="tradeDetails.currentCloseTime"/>
        </b-col>
        <b-col cols="6">
          <b-checkbox size="sm" class="ml-2" style="margin-top: 5px" v-model="tradeDetails.currentClosePrice">{{ $t('operations.current') }}</b-checkbox>
        </b-col>
        <b-col cols="6" >
          <b-checkbox size="sm" class="ml-2" style="margin-top: 5px" v-model="tradeDetails.currentCloseTime">{{ $t('operations.current') }}</b-checkbox>
        </b-col>
      </b-row>
      <div class="text-right">
        <b-button size="sm" variant="secondary" class="mr-2" @click="closeModal" :disabled="busy">
          {{ $t('operations.cancel') }}
        </b-button>
        <b-button size="sm" variant="danger" @click="closeOrders" :disabled="busy">
          {{ $t('operations.closeTrades') }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import TradeRequest from '@/model/trade/TradeRequest'
import TradeOrderSymbolDataPart from '@/components/modal/tradeOrderModalPart/tradeOrderSymbolDataPart.vue'
import DateTimePicker from '@/components/widget/picker/dateTimePicker.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TradeMassCloseOrderModal',
  components: { DateTimePicker, TradeOrderSymbolDataPart },
  data() {
    return {
      uniqueId: 0,
      dialog: {
        show: false,
        showGraph: false
      },
      busy: false,
      orders: [],
      symbolId: null,
      tradeDetails: TradeRequest(),
    }
  },
  created() {
    this.uniqueId = this._uid
    this.subscribeToTickers(true)
  },
  beforeDestroy() {
    this.subscribeToTickers(false)
  },
  computed:{
    ...mapGetters('symbol', ['tickersMap', 'getTicker']),
    orderIds(){
      return this.orders.map(o=>o.order)
    }
  },
  methods: {
    ...mapActions('notification',['subscribeToTickers']),
    ...mapActions('trade',['closeOrder']),
    showModal(orders, symbolId) {
      if(orders == null || orders.length === 0){
        return;
      }
      this.subscribeToTickers(true);
      this.orders = orders
      this.symbolId = symbolId
      this.dialog.show = true
      this.tradeDetails = TradeRequest({
        symbolId: symbolId, currentClosePrice: true, currentCloseTime: true,
        closePrice: this.getTicker(symbolId)?.ask || null,
      })
    },
    syncPrice(){
      const ticker = this.getTicker(this.tradeDetails.symbolId)
      if(ticker != null){
        this.tradeDetails.closePrice = ticker.ask
      }
    },
    closeOrders(){
      let $this = this;
      let request = {...this.tradeDetails};
      if(request.currentClosePrice !== false){
        delete request.currentClosePrice
      }
      if(request.currentCloseTime !== false){
        delete request.currentCloseTime
      }
      this.busy = true
      let promises = this.orders.map(order=>{
        let closeRequest = {...request, account: order.account, order: order.order}
        return $this.closeOrder({account: order.account, orderId: order.order, order: closeRequest})
      })
      Promise.all(promises).then(()=>{
        $this.closeModal()
        $this.$emit('changed')
      }).finally(()=> this.busy = false)

    },
    closeModal() {
      this.dialog.show = false
      this.symbolId = null
      this.orders = []
      this.busy = false
      this.tradeDetails = TradeRequest()
    },

  }

}
</script>


<style scoped>

</style>